import { getFormatMessage } from '@/utils/utils'
import { UpOutlined } from '@ant-design/icons'
import { Button, Dropdown, Menu, Space } from 'antd'
import React from 'react'
import styles from './actionbar.css'

export interface BoxActionbarProps {
  disabled?: boolean
  selectable?: boolean
  onSelect?: () => void
  onCheckAll?: () => void
  onMenuItemClick?: (key: string) => void
}

export const BoxActionbar: React.FC<BoxActionbarProps> = (
  props: BoxActionbarProps
) => {
  const { disabled, selectable, onSelect, onCheckAll, onMenuItemClick } = props
  const formatMessage = getFormatMessage()
  const menu = (
    <Menu>
      <Menu.Item
        key='contextmenu.delete'
        onClick={() => onMenuItemClick?.('delete')}
      >
        {formatMessage({ id: 'app.box.toolbar.batch.delete' })}
      </Menu.Item>
      <Menu.Item
        key='contextmenu.firmware'
        onClick={() => onMenuItemClick?.('firmware')}
      >
        {formatMessage({ id: 'app.box.toolbar.batch.firmware' })}
      </Menu.Item>
      <Menu.Item
        key='contextmenu.template'
        onClick={() => onMenuItemClick?.('template')}
      >
        {formatMessage({ id: 'app.box.toolbar.batch.template' })}
      </Menu.Item>
      <Menu.Item
        key='contextmenu.connection'
        onClick={() => onMenuItemClick?.('connection')}
      >
        {formatMessage({ id: 'app.box.toolbar.batch.connection' })}
      </Menu.Item>
      <Menu.Item
        key='contextmenu.time'
        onClick={() => onMenuItemClick?.('time')}
      >
        {formatMessage({ id: 'app.box.toolbar.batch.time' })}
      </Menu.Item>
      <Menu.Item
        key='contextmenu.clean'
        onClick={() => onMenuItemClick?.('clean')}
      >
        {formatMessage({ id: 'app.box.toolbar.batch.clean' })}
      </Menu.Item>
    </Menu>
  )

  return (
    <div className={styles.actionbar}>
      <Space>
        <Button type='primary' disabled={disabled} onClick={onSelect}>
          {selectable
            ? formatMessage({ id: 'app.box.toolbar.cancel' })
            : formatMessage({ id: 'app.box.toolbar.select' })}
        </Button>
        <Button disabled={!selectable} type='primary' onClick={onCheckAll}>
          {formatMessage({ id: 'app.box.toolbar.checkAll' })}
        </Button>
        <Dropdown disabled={!selectable} overlay={menu}>
          <Button type='primary'>
            <Space>
              {formatMessage({ id: 'app.box.toolbar.batch' })}
              <UpOutlined />
            </Space>
          </Button>
        </Dropdown>
      </Space>
    </div>
  )
}
